import { useCallback } from 'react';
import {
  useQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  OperationVariables,
  QueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllTalentAgenciesOrPartners.graphql';
import { Query } from '../../__generated__/globalTypes';

export const useAllTalentAgenciesOrPartnersQuery = (options?: QueryHookOptions<Query>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllTalentAgenciesOrPartnersLazyQuery = (
  options?: LazyQueryHookOptions<Query>
): QueryResult<Query> & { getAllTalentAgenciesOrPartnersQuery: LazyQueryExecFunction<Query, OperationVariables> } => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  // TODO: should be getAllTalentAgenciesOrPartners
  const [getAllTalentAgenciesOrPartnersQuery, result] = useLazyQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllTalentAgenciesOrPartnersQuery, ...result };
};

export const useAllTalentAgenciesOrPartnersPromiseQuery = () => {
  const client = useApolloClient();

  const getAllTalentAgenciesOrPartners = useCallback(
    (options?: Omit<QueryOptions<Record<string, unknown>, Query>, 'query'>) =>
      client.query<Query>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllTalentAgenciesOrPartners };
};
